import { render, staticRenderFns } from "./news.vue?vue&type=template&id=16234bcd&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=16234bcd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16234bcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16234bcd')) {
      api.createRecord('16234bcd', component.options)
    } else {
      api.reload('16234bcd', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=16234bcd&scoped=true&", function () {
      api.rerender('16234bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/search/news.vue"
export default component.exports